import { Label } from '@r1-frontend/ui-react/components/label';
import React from 'react';

import { LabelWrapper } from '~/src/components/ProductCard/styled';

const HeaderBlock = ({ labels }) => {
    return (
        <>
            {!!labels && !!labels?.length &&
                <LabelWrapper>
                    {
                        labels.map((item, index) => (
                            <Label
                                key={`header-label-${item.id}-${index}`}
                                data-test='router-item-label'
                                textColor={item.colorText || item.color_text}
                                bgColor={item.color}
                            >
                                {item.title}
                            </Label>
                        ))
                    }
                </LabelWrapper>
            }
        </>
    );
};

export default HeaderBlock;
